import { render, staticRenderFns } from "./ClientInputs.vue?vue&type=template&id=10016665&"
import script from "./ClientInputs.vue?vue&type=script&lang=ts&"
export * from "./ClientInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports